<div *ngFor="let choice of choices">
  <div class="card elevation-1">
    <div style="padding-bottom: 1rem;">
      <h5 [ngSwitch]="choice.oldItem.MWG_UPC_NUM === ''">
        <div *ngSwitchCase="true">You entered...</div>
        <div *ngSwitchDefault>We did not have...</div>
      </h5>
    </div>
    <app-product-list 
      [item]="choice.oldItem" 
      qtyField="SUBD_QTY" 
      display="oos"
    ></app-product-list>
    <div style="padding: 1rem 0;">
      <h5 [ngSwitch]="choice.newItem.MWG_UPC_NUM === ''">
        <div *ngSwitchCase="true">{{verbiage}}</div>
        <div *ngSwitchDefault>{{verbiage}}</div>
      </h5>
    </div>
    <app-product-list
      [item]="choice.newItem"
      qtyField="SHOPPED_QTY"
      display="sub"
    ></app-product-list>
    <div *ngIf="choiceOOS === true" class="columns is-mobile" style="margin-top: 1rem;">
      <div class="column">
        <a
          class="button full-width"
          [ngClass]="{
            'is-outlined': choice.isSubApproved === '',
            'is-danger': choice.isSubApproved === 'N'
          }"
          (click)="sendRejectDataBack(choice)"
        >
          <span>No Thanks</span>
        </a>
      </div>
      <div class="column">
        <a
          class="button full-width"
          [ngClass]="{
            'is-outlined': choice.isSubApproved === '',
            'is-success': choice.isSubApproved === 'Y'
          }"
          (click)="sendAcceptDataBack(choice)"
        >
          <span>Yes</span>
        </a>
      </div>
    </div>
  </div>
</div>